export enum PortDirection {
    Origin,
    Destination
}